import { Clear as DeleteIcon } from "@mui/icons-material";
import {
  Button,
  ButtonGroup,
  IconButton,
  SxProps,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const Confirm = ({
  confirm,
  cancel,
  label,
  sx,
}: {
  confirm: () => void;
  cancel: () => void;
  label: string;
  sx?: SxProps;
}) => (
  <ButtonGroup sx={{ backgroundColor: "#FF505A", ...sx }}>
    <IconButton disableFocusRipple aria-label="delete" onClick={cancel}>
      <DeleteIcon sx={{ color: "#FFFFFF" }} />
    </IconButton>
    <Button
      disableFocusRipple
      disableElevation
      variant="text"
      onClick={confirm}
    >
      <Typography variant="secondary" sx={{ color: "#FFFFFF" }}>
        {label}
      </Typography>
    </Button>
  </ButtonGroup>
);

type Props = {
  handleDelete: (id: string) => void;
  id?: string;
  sx?: SxProps;
  sxConfirm?: SxProps;
};

const DeleteButton = ({ handleDelete, id, sx, sxConfirm }: Props) => {
  const { t } = useTranslation();
  const [confirming, setConfirming] = useState(false);

  if (!id) {
    return <></>;
  }

  return (
    <>
      {confirming ? (
        <Confirm
          sx={sxConfirm}
          confirm={() => {
            handleDelete(id);
            setConfirming(false);
          }}
          cancel={() => setConfirming(false)}
          label={t("common:confirmDelete")}
        />
      ) : (
        <Button
          variant="text"
          startIcon={<DeleteIcon sx={{ color: "#00000085", ...sx }} />}
          onClick={() => setConfirming(true)}
        >
          <Typography color="textSecondary" fontSize="14px">
            {t("common:delete")}
          </Typography>
        </Button>
      )}
    </>
  );
};

export default DeleteButton;
